import './bootstrap'
import './refresh'
import '../css/style.css'

import * as Sentry from '@sentry/vue'
import { vMaska } from 'maska/vue'
import { createApp } from 'vue'
import VueApexCharts from 'vue3-apexcharts'
import VueAxios from 'vue-axios'
import Root from './components/Root.vue'
import axios from './axios'
import enums from './enums'
import helpers from './helpers'
import router from './router'
import store from './store'

const app = createApp(Root)

Sentry.init({
  app,
  dsn: import.meta.env.VITE_SENTRY_LARAVEL_DSN,
  integrations: [
    Sentry.browserTracingIntegration({ router })
  ],
  tracesSampleRate: import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE,
  // Sentry 11 collects more by default; keep the v10 baseline (no cookies, user info or bodies).
  dataCollection: {
    userInfo: false,
    cookies: false,
    httpHeaders: {
      request: { deny: ['forwarded', '-ip', 'remote-', 'via', '-user'] },
      response: { deny: ['forwarded', '-ip', 'remote-', 'via', '-user'] }
    },
    httpBodies: [],
    urlQueryParams: { deny: ['forwarded', '-ip', 'remote-', 'via', '-user'] },
    genAI: { inputs: false, outputs: false },
    databaseQueryData: false,
    queues: false,
    graphQL: { document: false, variables: false }
  },
  attachStacktrace: false
})

app.use(store)
app.use(router)
app.use(VueApexCharts)
app.use(VueAxios, axios)

app.directive('maska', vMaska)

app.mixin(enums)
app.mixin(helpers)

app.mount('#app')
